var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"memory__view memory__view--random"},_vm._l((_vm.state.records),function(record){return _c('img',{staticClass:"memory__view-item--random",style:(_vm.getStyle(record)),attrs:{"src":record.object.object_image}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }